module.exports = __webpack_public_path__ + "omniv2/img/icon-search.b8965610.svg";